export enum ConfigFieldsKeys {
  AdjustmentType = 'adjustmentType',
  AdjustmentAmount = 'adjustmentAmount',
}

export interface IConfigFields {
  [ConfigFieldsKeys.AdjustmentType]: string;
  [ConfigFieldsKeys.AdjustmentAmount]: string;
}
